import { Component, inject } from '@angular/core';
import { SynIconButtonComponent } from '@synergy-design-system/angular';
import { ThemeService } from '@core/services/theme.service';

/**
 * ThemeSwitchComponent
 *
 * Renders a single icon button that toggles between light and dark themes.
 * Uses Synergy's syn-icon-button with dark_mode/light_mode icons.
 */
@Component({
  selector: 'app-theme-switch',
  standalone: true,
  imports: [SynIconButtonComponent],
  template: `
    <syn-icon-button
      [name]="themeService.isDark() ? 'light_mode' : 'dark_mode_fill'"
      [label]="themeService.isDark() ? 'Switch to light mode' : 'Switch to dark mode'"
      (click)="themeService.toggle()"
      size="medium"
    ></syn-icon-button>
  `,
})
export class ThemeSwitchComponent {
  protected readonly themeService = inject(ThemeService);
}
